export const MODAL_TYPES = {
  CONNECT: 'connect',
  REQUEST: 'request',
  DECLINE: 'decline',
  INFO: 'info',
  GALLERY: 'gallery',
  CONFIRM: 'confirm',
  WITH_CHILD: 'with-child',
  BLOCKED: 'blocked-by-admin',
  LINK: 'link',
  MOBILE_MENU: 'mobile-menu',
  UNLINK: 'unlink',
  APPROVE_APPLICATION: 'approve-application',
};
